import $ from 'jquery';
import Swiper from 'swiper';

/**
 * Initialize Query Swiper carousels
 */
export function initQuerySwiper() {
	$('.scroll-query.swiper').each(function () {
		const $query = $(this);
		const queryId = $query.attr('id');

		if (queryId) {
			new Swiper(`#${queryId}`, {
				a11y: {
					enabled: true,
					slideRole: 'article',
				},
				navigation: {
					nextEl: `#${queryId} .swiper-button-next`,
					prevEl: `#${queryId} .swiper-button-prev`,
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 2.5,
						spaceBetween: 20,
					},
				},
			});
		}
	});
}
